<div class="custom-mat-dialog-form">
  <div>
    <div>
      Contract type local name
      <br />
      <h4 class="not-translated">{{this.data.TypeLocale}}</h4>
      <br />
      Correspond to contract type harmonized value: <br />
      <br />
    </div>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="mt-2">

        <mat-select placeholder="Please select" style="width:300px;" class='form-control'
          name="ContractType" required formControlName="ContractType">
          @for (c of ContractTypeHarmonizedValues; track c; let i = $index) {
            <mat-option value="{{c.ContractTypeId}}">
              {{c.ContractType}}
            </mat-option>
          }
        </mat-select>
      </div>

      <br />


      <div class="mt-2 right">
        <button type="button"
          class="btn btn-danger"
          (click)="onNoClick()">
          Cancel
        </button>
        <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">
          SAVE
        </button>
      </div>
    </form>
  </div>
</div>
